const sameStock = (item, medicine) => {
  if (!item || !medicine) return false;
  if (item.stock_medicine && medicine.id && item.stock_medicine === medicine.id) {
    return true;
  }
  const left = String(item.barcode || "").trim().toLowerCase();
  const right = String(medicine.barcode || "").trim().toLowerCase();
  return Boolean(left && right && left === right);
};

const cappedQty = (nextQty, available) => {
  const qty = Math.max(0, Number(nextQty) || 0);
  const max = Number(available);
  if (!Number.isFinite(max) || max <= 0) return qty;
  return Math.min(qty, max);
};

export const addOrIncrementStockItem = (items, medicine, quantity = 1) => {
  if (!medicine) return items;
  const qtyToAdd = Number(quantity) || 1;
  const existingIndex = items.findIndex((item) => sameStock(item, medicine));
  const available =
    Number(medicine.quantity) ||
    Number(items[existingIndex]?.available_stock) ||
    0;

  if (existingIndex >= 0) {
    return items.map((item, index) => {
      if (index !== existingIndex) return item;
      const sellPrice =
        parseFloat(item.sell_price) || parseFloat(item.price) || 0;
      const nextQty = cappedQty(
        (parseFloat(item.quantity) || 0) + qtyToAdd,
        item.available_stock || available,
      );
      return {
        ...item,
        quantity: nextQty,
        total_price: parseFloat((nextQty * sellPrice).toFixed(2)),
      };
    });
  }

  const sellPrice = parseFloat(medicine.sell_price) || 0;
  const nextQty = cappedQty(qtyToAdd, available);
  return [
    ...items,
    {
      stock_medicine: medicine.id,
      name: medicine.medicine_display,
      barcode: medicine.barcode,
      quantity: nextQty,
      sell_price: sellPrice,
      price: sellPrice,
      total_price: parseFloat((nextQty * sellPrice).toFixed(2)),
      available_stock: available,
      dosage: 1,
      notation: "",
      is_before: "after",
      units_per_meal: 1,
    },
  ];
};

export const addOrIncrementMedicineItem = (items, medicine, quantity = 1) => {
  if (!medicine) return items;
  const qtyToAdd = Number(quantity) || 1;
  const existingIndex = items.findIndex((item) => item.medicine === medicine.id);

  if (existingIndex >= 0) {
    return items.map((item, index) => {
      if (index !== existingIndex) return item;
      const currentQty = parseFloat(item.quantity) || 0;
      const nextQty = currentQty + qtyToAdd;
      const purchasePrice = parseFloat(item.purchase_price) || 0;
      return {
        ...item,
        quantity: nextQty,
        subtotal: nextQty * purchasePrice,
      };
    });
  }

  return [
    ...items,
    {
      medicine: medicine.id,
      name: medicine.name,
      barcode: medicine.barcode,
      quantity: qtyToAdd,
      purchase_price: "",
      sell_price: "",
      expiry_date: "",
      subtotal: 0,
    },
  ];
};

export const sumItemTotals = (items) =>
  parseFloat(
    items
      .reduce((sum, item) => sum + (parseFloat(item.total_price) || 0), 0)
      .toFixed(2),
  );
